import axios from 'axios';
import { getVisitorId } from './visitTracking';
import { setActivePromoEvent } from './activePromoEvent';

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Returns the default discount configuration (fallback)
 */
export const getDefaultDiscountConfig = () => ({
  promotionName: '',
  emoji: '',
  colors: {
    tagBackground: '#212121',
    tagText: '#f6cd00',
    discountedPrice: '#087E63',
    bundleBadgeBackground: '#265697'
  },
  tiers: [
    { imageCount: 6, discount: 5, enableDefault: true, exactAmount: false, coupons: ['GIFT5'] },
    { imageCount: 8, discount: 10, enableDefault: true, exactAmount: false, coupons: ['GIFT20'] },
    { imageCount: 9, discount: 20, enableDefault: false, exactAmount: false, fallbackToLower: true, coupons: ['GIFT9'] },
    { imageCount: 10, discount: 19.2, enableDefault: true, exactAmount: false, coupons: ['GIFT10'] },
    { imageCount: 12, discount: 25, enableDefault: true, exactAmount: false, coupons: ['GIFT12'] },
    { imageCount: 16, discount: 27, enableDefault: true, exactAmount: true, coupons: ['GIFT35'] },
    { imageCount: 24, discount: 30, enableDefault: true, exactAmount: false, coupons: ['GIFT40'] }
  ],
  uploadPromptTier: 12
});

/**
 * Fetches the current discount configuration from the server
 * @returns {Promise<Object>} The discount config data
 */
export const getDiscountConfig = async () => {
  try {
    const visitorId = getVisitorId();
    const response = await axios.get(`${BASE_URL}/discount-config`, { params: { visitorId } });

    if (response.data.status === 200) {
      // Capture which special-day event/variant priced this config (if any) so
      // the cart can be attributed to it. `event` is null on normal days.
      setActivePromoEvent(response.data.event || null);
      return response.data.data;
    }

    throw new Error('Failed to fetch discount configuration');
  } catch (error) {
    console.error('Error fetching discount config:', error);
    // Return default configuration if API call fails
    return getDefaultDiscountConfig();
  }
};

/**
 * Updates the discount configuration (admin only)
 * @param {Object} config - The new discount configuration
 * @param {string} token - Admin JWT token
 * @returns {Promise<Object>} The updated discount config data
 */
export const updateDiscountConfig = async (config, token) => {
  try {
    const response = await axios.put(`${BASE_URL}/discount-config`, config, {
      headers: {
        Authorization: token
      }
    });

    if (response.data.status === 200) {
      return response.data.data;
    }

    throw new Error('Failed to update discount configuration');
  } catch (error) {
    console.error('Error updating discount config:', error);
    throw error;
  }
};
